import {buildEntityNotification} from './entity-notification';
import {Contenitore} from '../_models/Contenitore';
import {Evento} from '../_models/Evento';
import {Movimento} from '../_models/Movimento';
import {Ordine} from '../_models/Ordine';
import {Risorsa} from '../_models/Risorsa';
import {SaveMessage} from './save-message';

type PopupPreviewType = 'warning' | 'error';

declare global {
  interface Window {
    archiConnectDebug?: {
      clearNotifications: () => void;
      previewNotificationColors: () => void;
      previewNotificationPopup: (type?: PopupPreviewType) => void;
      previewNotifications: () => void;
    };
  }
}

export function registerNotificationPreview(saveMessage: SaveMessage) {
  window.archiConnectDebug = {
    clearNotifications: () => saveMessage.clearNotifications(),
    previewNotificationColors: () => previewNotificationColors(saveMessage),
    previewNotificationPopup: (type?: PopupPreviewType) => previewNotificationPopup(saveMessage, type),
    previewNotifications: () => previewNotifications(saveMessage)
  };
}

function previewNotifications(saveMessage: SaveMessage) {
  saveMessage.clearNotifications();

  saveMessage.entityUpdated('risorsa', previewEntity<Risorsa>({
    codice: 'MO-010',
    descrizione: 'Mulino principale',
    reparto: 'Miscele',
    executedBy: 'Mario Rossi'
  }));

  saveMessage.entityCreated('movimento', previewEntity<Movimento>({
    id: 8421,
    codBox: 'BX-0042',
    codArt: 'ART-771',
    rifOdP: '205654.9.1',
    executedBy: 'Anna Bianchi'
  }));

  saveMessage.entityDeleted('evento', previewEntity<Evento>({
    id: 315,
    codiceRisorsa: 'MO-010',
    codiceArticolo: 'ART-771',
    rifOdP: '205654.9.1',
    executedBy: 'Luca Verdi'
  }));

  saveMessage.entityUpdated('ordine', previewEntity<Ordine>({
    idDocumento: 205654,
    idRiga: 9,
    idRigaLavorazione: 1,
    rifOdP: '205654.9.1',
    codiceArticolo: 'ART-771',
    codiceRisorsa: 'MO-010',
    executedBy: 'Sara Neri'
  }));

  saveMessage.entityEmptied('contenitore', previewEntity<Contenitore>({
    codice: 'BX-0042',
    rifOdP: '205654.9.1',
    codArt: 'ART-771',
    codLottoAlfa: 'LOT-2026-0316',
    executedBy: 'Paolo Galli'
  }));
}

function previewNotificationColors(saveMessage: SaveMessage) {
  saveMessage.clearNotifications();

  saveMessage.entityUpdated('risorsa', previewEntity<Risorsa>({
    codice: 'MO-010',
    executedBy: 'Mario Rossi'
  }));

  saveMessage.entityEmptied('contenitore', previewEntity<Contenitore>({
    codice: 'BX-0042',
    executedBy: 'Paolo Galli'
  }));

  saveMessage.entityDeleted('ordine', previewEntity<Ordine>({
    idDocumento: 205654,
    idRiga: 9,
    idRigaLavorazione: 1,
    rifOdP: '205654.9.1',
    executedBy: 'Sara Neri'
  }));
}

function previewNotificationPopup(saveMessage: SaveMessage, type: PopupPreviewType = 'warning') {
  const movimentoNotification = buildEntityNotification('updated', 'movimento', previewEntity<Movimento>({
    id: 8421,
    codBox: 'BX-0042',
    codArt: 'ART-771',
    rifOdP: '205654.9.1',
    executedBy: 'Anna Bianchi'
  }));

  const ordineNotification = buildEntityNotification('deleted', 'ordine', previewEntity<Ordine>({
    idDocumento: 205654,
    idRiga: 9,
    idRigaLavorazione: 1,
    rifOdP: '205654.9.1',
    codiceArticolo: 'ART-771',
    codiceRisorsa: 'MO-010',
    executedBy: 'Sara Neri'
  }));

  if (type === 'error') {
    saveMessage.messageError(ordineNotification);
    return;
  }

  saveMessage.messageWarning(movimentoNotification);
}

function previewEntity<T>(value: Partial<T> & Record<string, unknown>): T {
  return value as T;
}
